import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import moment from 'moment'
import { AppConfigService } from '../../../../app-config/app-config.service'
import { JmlLibConfig } from '../../../../jml-lib-config'
import { JML_LIB_CONFIG } from '../../../../jml-lib-config.token'
import { LicenseInfoItem, ServerInfo } from '../../../../models/app-config/server-info.model'
import DateTimeUtils from '../../../../utils/date-time.utils'
import { take } from 'rxjs/operators'

@Component({
  selector: 'jml-lib-build-info-dialog',
  templateUrl: './build-info-dialog.component.html',
  styleUrls: ['./build-info-dialog.component.scss']
})
export class BuildInfoDialogComponent implements OnInit {
  uiDetails: string
  company: {
    name: string
    street: string
    city: string
    email: string
  }
  appName: string
  licenseInfos: LicenseInfoItem[] = []
  systemInfos: any[]

  constructor(
    private appConfig: AppConfigService,
    @Inject(JML_LIB_CONFIG) private jmlLibConfig: JmlLibConfig
  ) {
    this.company = {
      name: jmlLibConfig.companyName,
      street: jmlLibConfig.companyStreet,
      city: jmlLibConfig.companyCity,
      email: jmlLibConfig.companyEmail
    }
    this.appName = jmlLibConfig.appName
    this.uiDetails = '...loading UI details'
    this.systemInfos = [
      { field: 'UI version', value: this.uiDetails },
      { field: 'BE host', value: 'loading BE host...' },
      { field: 'BE version', value: 'loading BE version' }
    ]
  }

  ngOnInit() {
    this.appConfig
      .getUIInfo$()
      .pipe(take(1))
      .subscribe((uiInfo) => {
        this.uiDetails = uiInfo.version + '.' + uiInfo.git_branch + '.' + uiInfo.build_no + '.' + uiInfo.git_sha
      })

    this.appConfig
      .getServerInfo$()
      .pipe(take(1))
      .subscribe((serverInfo) => {
        this.buildServerInfos(serverInfo)
      })
  }

  buildServerInfos(serverInfo: ServerInfo) {
    this.systemInfos = [
      { field: 'UI version', value: this.uiDetails },
      { field: 'BE host', value: serverInfo.host },
      { field: 'BE version', value: serverInfo.version }
    ]

    serverInfo.licenseInfos.forEach((license, index) => {
      if (typeof license.value !== 'number') {
        if (moment(license.value, 'YYYY-MM-DDTHH:mm:ss').isValid()) {
          this.licenseInfos.push({
            field: license.field,
            value: DateTimeUtils.apiDateTimeStringToCalendarString(license.value)
          })
        } else {
          this.licenseInfos.push({ field: license.field, value: license.value })
        }
      } else {
        this.licenseInfos.push({ field: license.field, value: license.value })
      }
    })
  }
}
